import { render, staticRenderFns } from "./chat-room.vue?vue&type=template&id=12364aa0&scoped=true&"
import script from "./chat-room.vue?vue&type=script&lang=js&"
export * from "./chat-room.vue?vue&type=script&lang=js&"
import style0 from "./chat-room.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./chat-room.vue?vue&type=style&index=1&id=12364aa0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12364aa0",
  null
  
)

component.options.__file = "chat-room.vue"
export default component.exports